<script setup lang="ts">
import { computed } from 'vue';
import { i18n } from '@/i18n';

const t = i18n.t;

/**
 * EzTableのゼロマッチ状態表示コンポーネント
 * 検索結果が0件の場合や、データが存在しない場合の表示を行う
 */

/**
 * Props定義
 */
interface Props {
  /** ゼロマッチメッセージ */
  message?: string;
  /** 説明文（省略可） */
  description?: string;
  /** カスタムCSSクラス（省略可） */
  customClass?: string;
}

const props = withDefaults(defineProps<Props>(), {
  message: '',
  description: '',
  customClass: '',
});

/**
 * 表示するメッセージを取得
 */
const displayMessage = computed(() => {
  return props.message || t('該当するデータはありません');
});
</script>

<template>
  <div :class="['ez-table-zero-match-state', customClass]">
    <div class="ez-table-zero-match-state__content">
      <div class="ez-table-zero-match-state__icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="5" width="18" height="14" rx="2" stroke="#9e9e9e" stroke-width="1.5" fill="none" />
          <line x1="3" y1="9" x2="21" y2="9" stroke="#9e9e9e" stroke-width="1.5" />
          <circle cx="12" cy="14" r="2" stroke="#9e9e9e" stroke-width="1.5" fill="none" />
          <path d="M12 14v-1M12 14v1" stroke="#9e9e9e" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>

      <div class="ez-table-zero-match-state__message">
        {{ displayMessage }}
      </div>

      <p v-if="description" class="ez-table-zero-match-state__description">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ez-table-zero-match-state {
  display: grid;
  place-items: center;
  padding: 48px 24px;
  min-height: 300px;
  height: 100%;
  background-color: $surfaceDefault;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    max-width: 400px;
    text-align: center;
  }

  &__icon {
    opacity: 0.6;
  }

  &__message {
    font-size: 16px;
    color: #757575;
    font-weight: 500;
    margin: 0;
  }

  &__description {
    font-size: 14px;
    color: #9e9e9e;
    line-height: 1.5;
    margin: 0;
    font-weight: 400;
  }
}
</style>
